export default "__VITE_ASSET__DbBV8Xch__"